import angular from 'angular';
import _ from 'lodash';

(function() {
  'use strict';
  angular.module('app.core').factory('OrderLine', OrderLineData);

  OrderLineData.$inject = ['ORDERS'];

  /* @ngInject */
  function OrderLineData(ORDERS) {
    OrderLine.prototype = {
      build: build,
      getStatusColor: getStatusColor
    };

    function OrderLine(orderLineData) {
      if (orderLineData) {
        this.build(orderLineData);
      }
    }

    return OrderLine;

    /////////////////////

    function build(orderLineData) {
      this.sellerProductIdentifier = orderLineData.sellerProductIdentifier || null;
      this.status = orderLineData.status || null;
      this.note = orderLineData.note || null;
      this.quantity = orderLineData.quantity;
      this.billedQuantity = orderLineData.billedQuantity;
      this.unitPrice = orderLineData.unitPrice;
      this.exclusiveTaxAmountLine = orderLineData.exclusiveTaxAmountLine;
    }

    /**
     * Récupère la couleur associée à la ligne.
     */
    function getStatusColor() {
      return _.result(_.find(ORDERS.status, { id: angular.lowercase(this.status) }), 'color');
    }
  }
})();
